import React, { useMemo, useState } from "react";
import styles from "../../assets/styles/AppHome/Audit.module.scss";
import {
  AppPage,
  MimaButton,
  MimaNewFilter,
  MimaTable,
} from "../../components";
import constant from "../../utils/constant";
import moment from "moment";

const Marketers = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  filterHandler,
}) => {
  const [showFilter, setShowFilter] = useState(false);

  const filterByData = [{ value: "Status", key: "status" }];

  const statusParams = [
    { value: "ACTIVE", key: "ACTIVE" },
    { value: "INACTIVE", key: "INACTIVE" },
    { value: "TERMINATED", key: "TERMINATED" },
  ];

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.marketers || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Sign up Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY")}</span>;
      },
    },
    {
      Header: "Marketer Name",
      accessor: "marketer",
      Cell: ({ cell }) => {
        const firstname = cell.row.original?.firstname;
        const lastname = cell.row.original?.lastname;
        const marketer = `${firstname} ${lastname}`;
        return <span>{marketer}</span>;
      },
    },
    {
      Header: "Marketer Email",
      accessor: "email",
    },
    {
      Header: "Phone Number",
      accessor: "mobile",
    },
    {
      Header: "Referrer Code",
      accessor: "referrerCode",
    },
    {
      Header: "Marketer Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const styleClass = `status ${status === "ACTIVE" ? "status__green" : status === "INACTIVE" ? "status__dark__yellow" : status === "TERMINATED" ? "status__grey" : ""}`;
        return <span className={styleClass}>{status}</span>;
      },
    },
  ];
  return (
    <AppPage pageTitle="All Marketers">
      <div>
        <MimaButton
          title={showFilter ? "Close Filter" : "Filter"}
          onClick={() => setShowFilter(!showFilter)}
          mt={5}
        />
      </div>
      <MimaNewFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        filterByData={filterByData}
        filterHandler={filterHandler}
        statusParams={statusParams}
      />
      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />
    </AppPage>
  );
};
export default Marketers;
